import { render, staticRenderFns } from "./ArtisanDate.vue?vue&type=template&id=28ec8ed1"
import script from "./ArtisanDate.vue?vue&type=script&lang=js"
export * from "./ArtisanDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports